import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb35f8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CreateList_Title" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 4,
  class: "CreateList_operationWrapper"
}
const _hoisted_6 = { style: {"display":"flex","gap":"5px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_message" }, "リスト一覧へ戻る", -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "error-message pl-3" }, "*必須項目", -1))
const _hoisted_10 = { class: "CreateList_BtnBlock" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "loading"
}
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = {
  key: 1,
  class: "loading"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = {
  key: 1,
  class: "loading"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "アップロード", -1))
const _hoisted_19 = { class: "CreateList_TableContainer" }
const _hoisted_20 = { class: "CreateList_Table" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("リスト名"),
  /*#__PURE__*/_createElementVNode("span", { class: "error-message pl-3" }, "*")
], -1))
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "error-message"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "説明", -1))
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "error-message"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "画像", -1))
const _hoisted_28 = { class: "CreateList_Table_Img" }
const _hoisted_29 = { class: "CreateList_Table_Imgprev" }
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  class: "error-message"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createTextVNode("表示期間"),
  /*#__PURE__*/_createElementVNode("span", { class: "error-message pl-3" }, "*")
], -1))
const _hoisted_33 = ["disabled"]
const _hoisted_34 = ["disabled"]
const _hoisted_35 = { class: "CreateList_MukigenCheck" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mukigenCheck" }, "無期限", -1))
const _hoisted_37 = ["disabled"]
const _hoisted_38 = {
  key: 0,
  class: "error-message"
}
const _hoisted_39 = { class: "CreateList_Table" }
const _hoisted_40 = { class: "tr_syosi" }
const _hoisted_41 = {
  key: 0,
  class: "syosi_table_container"
}
const _hoisted_42 = {
  key: 0,
  class: "syosi_table_info"
}
const _hoisted_43 = { class: "syosi_table_info_message" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info-message" }, " 〇ドラッグ&ドロップで並び替えができます ", -1))
const _hoisted_45 = {
  key: 0,
  class: "error-message"
}
const _hoisted_46 = {
  key: 1,
  class: "error-message"
}
const _hoisted_47 = { class: "syosi_table_base_midasi" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "ISBN 書誌CD 出版書誌CD", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "フリー入力欄", -1))
const _hoisted_52 = { class: "syosi_table_content" }
const _hoisted_53 = { class: "syosi_table_base" }
const _hoisted_54 = { class: "syosi_table_base_content" }
const _hoisted_55 = ["onUpdate:modelValue", "onDblclick", "onFocus", "onChange"]
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "cd_input" }
const _hoisted_58 = ["onUpdate:modelValue"]
const _hoisted_59 = { key: 1 }
const _hoisted_60 = { class: "syosi_table_list" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "row_no Sticky_Row1" }, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "row_no Sticky_Row2" }, [
  /*#__PURE__*/_createTextVNode("行"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("No")
], -1))
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "midasi_toritugi Sticky_Row3" }, [
  /*#__PURE__*/_createTextVNode(" 取次情報"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("登録日 ")
], -1))
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "midasi_syoten Sticky_Row4" }, [
  /*#__PURE__*/_createTextVNode(" 書店コード/番線"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("書店名 ")
], -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "備考", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "削除", -1))
const _hoisted_67 = { class: "row_no Sticky_Row1" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = { class: "row_no Sticky_Row2" }
const _hoisted_70 = {
  key: 0,
  class: "duplicated"
}
const _hoisted_71 = { class: "Sticky_Row3" }
const _hoisted_72 = ["value", "onChange", "disabled"]
const _hoisted_73 = ["value"]
const _hoisted_74 = { style: {"text-align":"center"} }
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = { class: "syosi_table_list_syoten Sticky_Row4" }
const _hoisted_77 = ["onUpdate:modelValue", "onDblclick", "onFocus"]
const _hoisted_78 = ["value"]
const _hoisted_79 = ["onUpdate:modelValue"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = ["onUpdate:modelValue"]
const _hoisted_82 = ["onUpdate:modelValue", "onFocus", "onChange", "onBlur"]
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { style: {"text-align":"center"} }
const _hoisted_85 = ["onUpdate:modelValue"]
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { style: {"text-align":"center"} }
const _hoisted_88 = {
  key: 1,
  class: "syosi_table_addbtn"
}
const _hoisted_89 = { class: "add_column" }
const _hoisted_90 = { class: "total_busu" }
const _hoisted_91 = {
  key: 1,
  class: "ResultMessageNull"
}
const _hoisted_92 = {
  key: 5,
  class: "CreateList_BtnBlock"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_message" }, "キャンセル", -1))
const _hoisted_94 = [
  _hoisted_93
]
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "btn_message" }, "登録", -1))
const _hoisted_96 = [
  _hoisted_95
]

import PankuzuHeader from "../components/PankuzuHeader.vue";
import ModalSyosiList, {
  ZaikoData_Result,
} from "@/components/modal/ModalSyosiList.vue";
import ModalShopList from "@/components/modal/ModalShopList.vue";
import { computed, nextTick, onBeforeUpdate, reactive, ref, watch } from "vue";
import {
  RouteLocationNormalized,
  onBeforeRouteLeave,
  useRoute,
  useRouter,
} from "vue-router";
import { useStore } from "vuex";
import { Notyf } from "notyf";
import axios, { AxiosResponse } from "axios";
import { ZaikoData } from "@/types/zaiko";
import ModalWarningMessage from "@/components/modal/ModalWarningMessage.vue";
import * as xlsx from "xlsx";
import mediumZoom from "medium-zoom";
import draggable from "vuedraggable";

//ぱんくずヘッダー
type PreOrderList = typeof preOrderList.value[0]; // 型定義
// 書誌リスト（リスト上部表示、移動用）
type BaseSyosiList = typeof baseSyosiList.value[0];

// APIからの取得データを保持

export default /*#__PURE__*/_defineComponent({
  __name: 'NewPreOrderList',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader"],
  setup(__props, { emit: __emit }) {

const currentPathList = [
  { name: "受注入力" },
  { name: "事前注文リスト作成" },
  { name: "新規事前注文リスト作成" },
];
// ナビゲーションガード---------------------------------------------
// 未更新データがある場合、画面遷移前に確認する
let navTo: RouteLocationNormalized; // ナビゲーション先
let fromModalNav = false; // モーダルから遷移する場合はダイアログを表示させないようにするフラグ
onBeforeRouteLeave(async (to, from) => {
  // ダイアログ表示
  if (isCreateNewList) {
    if (
      (inputItem.value.listName !== "" ||
        inputItem.value.explanation !== "" ||
        inputImg.value.files[0] !== undefined ||
        inputItem.value.startDate !== "" ||
        inputItem.value.endDate !== "" ||
        baseSyosiList.value.length > 1 ||
        preOrderList.value.length > 1) &&
      !fromModalNav
    ) {
      navTo = to;
      warningModalVisible.value = true;
      return false;
    }
  } else {
    if (
      (inputItem.value.listName !== savedListData.value.listName ||
        inputItem.value.explanation !== savedListData.value.description ||
        inputItem.value.startDate !== savedListData.value.startDate ||
        inputItem.value.endDate !== savedListData.value.endDate ||
        imgUrl.value !== savedListData.value.imagePath ||
        compareSyosiData()) &&
      !fromModalNav
    ) {
      navTo = to;
      warningModalVisible.value = true;
      return false;
    }
  }
});
// 保存データと入力データの書誌を比べる
const compareSyosiData = () => {
  if (
    JSON.stringify(baseSyosiList.value) !== JSON.stringify(initBaseSyosiList) ||
    JSON.stringify(preOrderList.value) !== JSON.stringify(initPreOrderList)
  ) {
    return true;
  } else {
    return false;
  }
};

// 初期設定------------------------------------------------------
const notyf = new Notyf();
const router = useRouter();
const route = useRoute();
const store = useStore();
const props = __props;
const emit = __emit;
// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

// 表示データ関連--------------------------------------------------
const isCreateNewList = route.params.id === "-1" ? true : false; // 新規作成:true/既存データの編集:false
const fromDashboard = Number(route.query.fromDashboard) === 1 ? true : false; // ダッシュボードの操作ログ参照か否か

if (fromDashboard) {
  emit("toggleGlobalHeader");
}
// 入力項目
// 日付追加用の処理
const createRegisterDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;
  const day = today.getDate();
  const targetDate =
    year.toString().padStart(2, "0") +
    "-" +
    month.toString().padStart(2, "0") +
    "-" +
    day.toString().padStart(2, "0");
  return targetDate;
};
// リストデータ
const inputItem = ref({
  listName: "",
  startDate: "",
  endDate: "",
  explanation: "",
});
// 注文リスト
const preOrderList = ref([
  {
    syoten: {
      toritugiCd: "",
      toritugiSyotenCd: "",
      syotenMei: "",
      bansen: "",
      rowNumber: 1,
      duplicate: false,
      registerDate: createRegisterDate() as string | null,
      remarks: null as string | null,
    },
    syosiList: [
      {
        janCd: "",
        columnNumber: 1,
        quantity: null as number | null,
      },
    ],
  },
]);
const baseSyosiList = ref([
  {
    janCd: "",
    displayCode: "",
    syosiMei: "",
    columnNumber: 1,
    freeword: "" as string | null,
  },
]);
const savedListData = ref({
  id: -1,
  listName: "",
  version: -1,
  description: "",
  registerDate: "",
  startDate: "",
  endDate: "",
  displayDataList: [
    {
      syoten: {
        toritugiCd: "101",
        toritugiSyotenCd: "01631",
        syotenMei: "網走文化会館",
        rowNumber: -1,
        bansen: "",
        duplicate: false,
        registerDate: null as string | null,
        remarks: null as string | null,
      },
      syosiList: [
        {
          janCd: "9784253181501",
          columnNumber: -1,
          quantity: -1,
          freeword: "" as string | null,
        },
      ],
    },
  ],
  imagePath: "",
});
let initBaseSyosiList = [] as BaseSyosiList[];
let initPreOrderList = [] as PreOrderList[];

// リスト開閉フラグ
const isListOpen = ref(isCreateNewList || fromDashboard ? true : false);

// 表示期間の無期限チェック
const isIndefinite = ref(false);

// 表示データ取得
const getListData = async () => {
  try {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/pre/chumon/get-detail?listId=${route.params.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    await setPreOrderListData(res.data);
    await nextTick();
    mediumZoom(document.querySelectorAll("img"), {
      background: "#696969",
      scrollOffset: 100,
      container: {
        top: 30,
        bottom: 30,
      },
    });
    if (savedListData.value.displayDataList.length) {
      nextTick(function () {
        toScrollTableBottom();
        selects.value[selects.value.length - 1].focus();
      });
    }
  } catch (error) {
    console.log(error);
    alert("リストデータが取得できませんでした");
  }
};
if (!isCreateNewList) getListData();

// APIから取得したデータを格納する
const setPreOrderListData = async (getData: any) => {
  // 戻り値を保存
  savedListData.value = getData;
  savedListData.value.startDate =
    savedListData.value.startDate === null ? "" : savedListData.value.startDate;
  savedListData.value.endDate =
    savedListData.value.endDate === "9999-12-31"
      ? ""
      : savedListData.value.endDate;
  if (
    savedListData.value.imagePath !== null &&
    !savedListData.value.imagePath.includes("juchu-connect")
  ) {
    savedListData.value.imagePath = `data:image;base64,${savedListData.value.imagePath}`;
  } else if (savedListData.value.imagePath === null) {
    savedListData.value.imagePath = "";
  }
  // savedListData.value.imagePath =
  //   savedListData.value.imagePath !== null
  //     ? `data:image;base64,${savedListData.value.imagePath}`
  //     : "";

  // 表示用配列に格納
  inputItem.value.listName =
    savedListData.value.listName === null ? "" : savedListData.value.listName;
  inputItem.value.explanation =
    savedListData.value.description === null
      ? ""
      : savedListData.value.description;
  inputItem.value.startDate = savedListData.value.startDate;
  inputItem.value.endDate = savedListData.value.endDate;
  imgUrl.value =
    savedListData.value.imagePath !== null ? savedListData.value.imagePath : "";
  // APIから取得したデータを番号順に並び変える
  savedListData.value.displayDataList.forEach((dispData) => {
    dispData.syosiList.sort((a, b) => {
      return a.columnNumber - b.columnNumber;
    });
  });
  savedListData.value.displayDataList.sort((a, b) => {
    return a.syoten.rowNumber - b.syoten.rowNumber;
  });
  // 書誌リストに格納
  baseSyosiList.value.splice(0);
  for (const syosi of savedListData.value.displayDataList[0].syosiList) {
    const syosiRes = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi?syosiCd=${syosi.janCd}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    const syosiTitle =
      syosiRes.data.syosiList.length > 0
        ? syosiRes.data.syosiList[0].title
        : "";
    // 表示用
    baseSyosiList.value.push({
      janCd: syosi.janCd,
      displayCode: syosi.janCd,
      syosiMei: syosiTitle,
      columnNumber: syosi.columnNumber,
      freeword: syosi.freeword,
    });
    // 変更検知用
    initBaseSyosiList.push({
      janCd: syosi.janCd,
      displayCode: syosi.janCd,
      syosiMei: syosiTitle,
      columnNumber: syosi.columnNumber,
      freeword: syosi.freeword,
    });
  }
  // 注文リストに格納
  preOrderList.value.splice(0);
  // savedListData.value.displayDataList.forEach((dispData) => {
  //   // 表示用
  //   preOrderList.value.push(dispData);
  //   // 変更検知用
  //   initPreOrderList.push({...dispData});
  // });

  // 表示用
  preOrderList.value = JSON.parse(
    JSON.stringify(savedListData.value.displayDataList)
  );
  // 変更検知用
  initPreOrderList = JSON.parse(
    JSON.stringify(savedListData.value.displayDataList)
  );
  // 表示期限が無期限だったらフラグを立てる
  if (
    savedListData.value.startDate === "" &&
    savedListData.value.endDate === ""
  ) {
    isIndefinite.value = true;
  }
};

// フリー入力時、書誌入力を制限する
const restrictSyosiInput = (baseSyosi: BaseSyosiList) => {
  if (baseSyosi.freeword !== "" && baseSyosi.freeword !== null) {
    return true;
  } else {
    return false;
  }
};

// 登録日を表示用フォーマットに加工して返す
const formatRegisterDate = (date: string | null) => {
  if (typeof date === "string") {
    const targetDate = new Date(date);
    const year = targetDate.getFullYear();
    const month = targetDate.getMonth() + 1;
    const day = targetDate.getDate();
    return year + "/" + month + "/" + day;
  } else {
    return null;
  }
};

// 明細追加関連-----------------------------------------------------------
// 列追加
const addBaseMeisai = () => {
  baseSyosiList.value.push({
    janCd: "",
    displayCode: "",
    syosiMei: "",
    columnNumber: baseSyosiList.value.length + 1,
    freeword: "",
  });
  preOrderList.value.forEach((preList) => {
    preList.syosiList.push({
      janCd: "",
      columnNumber: preList.syosiList.length + 1,
      quantity: null,
    });
  });
  nextTick(function () {
    toScrollTableRight();
  });
};

// 行追加
const addPreOrderMeisai = () => {
  let addData = {
    syoten: {
      toritugiCd: "",
      toritugiSyotenCd: "",
      syotenMei: "",
      bansen: "",
      rowNumber: preOrderList.value.length + 1,
      duplicate: false,
      registerDate: createRegisterDate(),
      remarks: null as string | null,
    },
    syosiList: [
      {
        janCd: "",
        columnNumber: 1,
        quantity: null as number | null,
      },
    ],
  };
  addData.syosiList.splice(0);
  for (let i = 1; i <= baseSyosiList.value.length; i++) {
    addData.syosiList.push({
      janCd: "",
      columnNumber: i,
      quantity: null as number | null,
    });
  }
  preOrderList.value.push(addData);
  nextTick(function () {
    toScrollTableBottom();
    selects.value[selects.value.length - 1].focus();
  });
};
// 行フォーカス用
const selects = ref<HTMLSelectElement[]>([]);
const setSelectRef = (el: any) => {
  if (el) {
    selects.value.push(el);
  }
};
onBeforeUpdate(() => {
  selects.value = [];
});

// 明細削除関連----------------------------------------------------------
// 列削除
const deleteColumn = (index: number) => {
  let targetColNum = baseSyosiList.value[index].columnNumber;
  if (confirm(`列${targetColNum}を削除してもよろしいですか？`)) {
    baseSyosiList.value.splice(index, 1);
    preOrderList.value.forEach((preList) => {
      preList.syosiList.splice(
        preList.syosiList.findIndex(
          ({ columnNumber }) => columnNumber === targetColNum
        ),
        1
      );
    });
    // 列データが一つもなかったら空データを追加
    if (baseSyosiList.value.length === 0) {
      addBaseMeisai();
    }
    reNumCol();
    notyf.success(`列${targetColNum}を削除しました`);
  }
};
// 行削除
const deleteRow = (index: number) => {
  if (confirm(`行${index + 1}を削除してもよろしいですか？`)) {
    preOrderList.value.splice(index, 1);
    // 行データが一つもなかったら空データを追加
    if (preOrderList.value.length === 0) {
      addPreOrderMeisai();
    }
    reNumRow();
    notyf.success(`行${index + 1}を削除しました`);
  }
};

// 書誌全削除
const deleteAll = () => {
  if (confirm("データを全て削除してよろしいですか？")) {
    preOrderList.value.splice(0);
    baseSyosiList.value.splice(0);
    preOrderList.value.push({
      syoten: {
        toritugiCd: "",
        toritugiSyotenCd: "",
        syotenMei: "",
        bansen: "",
        rowNumber: 1,
        duplicate: false,
        registerDate: createRegisterDate(),
        remarks: null as string | null,
      },
      syosiList: [
        {
          janCd: "",
          columnNumber: 1,
          quantity: null as number | null,
        },
      ],
    });
    baseSyosiList.value.push({
      janCd: "",
      displayCode: "",
      syosiMei: "",
      columnNumber: 1,
      freeword: "",
    });
  }
};

// 注文リスト入替処理関連--------------------------------------------------------
// 列Noの振り直し
const reNumCol = () => {
  baseSyosiList.value.forEach((base, baseIndex) => {
    base.columnNumber = baseIndex + 1;
  });
  preOrderList.value.forEach((preList) => {
    preList.syosiList.forEach((syosi, syosiIndex) => {
      syosi.columnNumber = syosiIndex + 1;
    });
  });
};
// 行Noの振り直し
const reNumRow = () => {
  preOrderList.value.forEach((preList, preIndex) => {
    preList.syoten.rowNumber = preIndex + 1;
  });
};
// 書誌(列)の並び替え発生時
const onSortSyosi = (item: any) => {
  const targetElement = item.moved;
  const targetColNum = targetElement.element.columnNumber;
  preOrderList.value.forEach((preList) => {
    const targetSyosi = preList.syosiList.find(
      (syosi) => syosi.columnNumber === targetColNum
    );
    preList.syosiList.splice(targetElement.oldIndex, 1);
    if (targetSyosi !== undefined)
      preList.syosiList.splice(targetElement.newIndex, 0, targetSyosi);
  });
  reNumCol();
  // console.log(preOrderList.value);
};
// 書店(行)の並び替え発生時
const onSortSyoten = (item: any) => {
  reNumRow();
};

// バリデーション関連-----------------------------------------------------
// リスト名
const listNameError = ref({
  hasError: false,
  message: "",
});
// 説明文
const explanationError = ref({
  hasError: false,
  message: "",
});
// 画像
const imgError = ref({
  hasError: false,
  message: "",
});
// 表示期間
const displayPeriodError = ref({
  hasError: false,
  message: "",
});
// 書誌
const syosiError = ref({
  hasError: false,
  message: "",
});
// 書店
const syotenError = ref({
  hasError: false,
  message: "",
});
// 即時バリデーション---------------
watch(
  () => inputItem.value.explanation,
  (explanation) => {
    // 説明文
    if (explanation.length > 40) {
      explanationError.value.hasError = true;
      explanationError.value.message = "説明は40文字以内で入力してください";
    } else {
      explanationError.value.hasError = false;
      explanationError.value.message = "";
    }
  }
);
watch(
  () => [
    {
      startDate: inputItem.value.startDate,
      endDate: inputItem.value.endDate,
      isIndefinite: isIndefinite.value,
    },
  ],
  (date) => {
    // 表示期間
    if (
      date[0].startDate !== "" &&
      date[0].endDate !== "" &&
      !isIndefinite.value
    ) {
      if (date[0].startDate > date[0].endDate) {
        displayPeriodError.value.hasError = true;
        displayPeriodError.value.message = "開始日が終了日を上回っています";
      } else {
        displayPeriodError.value.hasError = false;
        displayPeriodError.value.message = "";
      }
    } else {
      displayPeriodError.value.hasError = false;
      displayPeriodError.value.message = "";
    }
  }
);
// 画像
const validImg = (size: number) => {
  const limitSize = 1000000; // サイズ上限3MB
  if (size > limitSize) {
    imgError.value.hasError = true;
    imgError.value.message = `ファイルの上限サイズ${
      limitSize / 1000000
    }MBを超えています`;
    return true;
  } else {
    imgError.value.hasError = false;
    imgError.value.message = "";
    return false;
  }
};

// 登録時バリデーション-------------
const validateOnRegister = () => {
  // 表示期間
  if (!displayPeriodError.value.hasError) {
    displayPeriodError.value.hasError = false;
    displayPeriodError.value.message = "";
    if (
      !isIndefinite.value &&
      (inputItem.value.startDate === "" || inputItem.value.endDate === "")
    ) {
      displayPeriodError.value.hasError = true;
      displayPeriodError.value.message = "表示期間を入力してください";
    }
  }
  // リスト名
  if (inputItem.value.listName === "") {
    listNameError.value.hasError = true;
    listNameError.value.message = "リスト名を入力してください";
  } else {
    listNameError.value.hasError = false;
    listNameError.value.message = "";
  }
  // 書誌
  for (let baseSyosi of baseSyosiList.value) {
    const hasFreeword = restrictSyosiInput(baseSyosi);
    if (!hasFreeword && (baseSyosi.janCd === "" || baseSyosi.janCd == null)) {
      syosiError.value.hasError = true;
      syosiError.value.message = "書誌を選択してください";
      break;
    } else {
      syosiError.value.hasError = false;
      syosiError.value.message = "";
    }
  }
  // 書店
  for (let preOrder of preOrderList.value) {
    if (preOrder.syoten.toritugiSyotenCd === "") {
      syotenError.value.hasError = true;
      syotenError.value.message = "書店を選択してください";
      break;
    } else {
      syotenError.value.hasError = false;
      syotenError.value.message = "";
    }
  }

  // エラーの有無を返す
  if (
    listNameError.value.hasError ||
    explanationError.value.hasError ||
    imgError.value.hasError ||
    displayPeriodError.value.hasError ||
    syosiError.value.hasError ||
    syotenError.value.hasError
  ) {
    return true;
  } else {
    return false;
  }
};

// 書誌関連----------------------------------------------------------
// 書誌検索モーダル
const syosiModalVisible = ref(false); // 表示制御フラグ
let changeSyosiTarget = ref({} as typeof baseSyosiList.value[0]); // 上部書誌リストの変更対象オブジェクトを格納
let holdSyosiCord = ""; // 入力値が異なるときに前の値に戻す用に保持
const syosiIkkatuFlg = ref(false); // 一括書誌設定フラグ
const focusSyosiInput = ref(false); // ドラッグ可フラグ
// 直接コード入力されたとき↓↓
// フォーカス時に値を保存
const focusSyosiCd = (orderIndex: number) => {
  changeSyosiTarget.value = baseSyosiList.value[orderIndex];
  focusSyosiInput.value = true;
  holdSyosiCord = baseSyosiList.value[orderIndex].displayCode;
};
const searchSyosi = async (event: any, index: number): Promise<void> => {
  // 入力値が空だったら各値をリセットする
  if (event.target.value === "") {
    // 書誌リスト
    changeSyosiTarget.value.janCd = "";
    changeSyosiTarget.value.displayCode = "";
    changeSyosiTarget.value.syosiMei = "";
    // 注文リスト
    preOrderList.value.forEach((preList) => {
      preList.syosiList[index].janCd = "";
    });
  } else {
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/syosi?syosiCd=${event.target.value}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data.syosiList.length > 0) {
      ref_selectSyosi(res.data.syosiList[0], event.target.value);
    } else {
      //該当する書店が無ければエラーメッセージ表示
      changeSyosiTarget.value.displayCode = holdSyosiCord;
      notyf.error("該当する書誌がありません");
    }
  }
};
// モーダルから検索されたとき↓↓
const openSearchSyosiModal = (orderIndex: number) => {
  changeSyosiTarget.value = baseSyosiList.value[orderIndex];
  syosiModalVisible.value = true;
};
// 単独選択
const ref_selectSyosi = (selectedValue: ZaikoData, displayCode?: string) => {
  if (checkDuplicatedSyosi(selectedValue.janCd)) {
    changeSyosiTarget.value.displayCode = holdSyosiCord;
    notyf.error("この書誌は既に追加されています");
  } else {
    changeSyosiTarget.value.displayCode =
      displayCode !== undefined ? displayCode : selectedValue.janCd;
    changeSyosiTarget.value.janCd = selectedValue.janCd;
    changeSyosiTarget.value.syosiMei = selectedValue.title;
    preOrderList.value.forEach((preOrder) => {
      preOrder.syosiList.forEach((preSyosi) => {
        if (preSyosi.columnNumber === changeSyosiTarget.value.columnNumber) {
          preSyosi.janCd = changeSyosiTarget.value.janCd;
        }
      });
    });
  }
};
// 一括選択
const ref_selectMultiSyosi = (selectedSyosiList: ZaikoData_Result[]) => {
  // 空データが1件のみ入っている場合は削除する
  if (baseSyosiList.value.length === 1) {
    let isNotEditSyosi = true;
    let isNotEditSyoten = true;
    if (baseSyosiList.value[0].janCd !== "") {
      isNotEditSyosi = false;
    }
    preOrderList.value.forEach((syoten) => {
      syoten.syosiList.forEach((syosi) => {
        if (syosi.quantity !== null) {
          isNotEditSyoten = false;
        }
      });
    });
    if (isNotEditSyosi && isNotEditSyoten) {
      baseSyosiList.value.splice(0, 1);
      preOrderList.value.forEach((syoten) => {
        syoten.syosiList.splice(0, 1);
      });
    }
  }

  selectedSyosiList.forEach((syosi) => {
    if (!checkDuplicatedSyosi(syosi.janCd as string)) {
      baseSyosiList.value.push({
        janCd: syosi.janCd,
        displayCode: syosi.janCd,
        syosiMei: syosi.title,
        columnNumber: baseSyosiList.value.length + 1,
        freeword: "",
      });
      preOrderList.value.forEach((preList) => {
        preList.syosiList.push({
          janCd: syosi.janCd,
          columnNumber: preList.syosiList.length + 1,
          quantity: null,
        });
      });
    }
  });
  notyf.success("書誌を追加しました(追加済の書誌はスキップ)");
};
// 重複した書誌データがあったらエラー
const checkDuplicatedSyosi = (janCd: string) => {
  let isDuplicated = false;
  baseSyosiList.value.forEach((baseList) => {
    if (baseList.janCd === janCd) isDuplicated = true;
  });
  return isDuplicated;
};

// 書店関連-------------------------------------------------------------
//取次リスト----------------------------
const toritugiList = computed(() => {
  return store.getters["constant/getToritugiList"];
});
// 取次入力
const inputToritugi = (event: any, index: number) => {
  // ターゲットデータの取次情報を更新
  preOrderList.value[index].syoten.toritugiCd = event.target.value;
  // ターゲットデータの書店情報をリセット
  preOrderList.value[index].syoten.toritugiSyotenCd = "";
  preOrderList.value[index].syoten.syotenMei = "";
  preOrderList.value[index].syoten.bansen = "";
};
// 書店検索関連----------------------------
// 書店コードモーダル
const shopModalVisible = ref(false); // 表示制御フラグ
const propToritugiCd = ref(""); // 書店検索モーダルに渡す取次CD
let changeSyotenTarget = ref({} as PreOrderList);
let holdSyotenCd = "";
const focusSyotenInput = ref(false);
// 直接コード入力されたとき↓↓
const focusSyotenCd = (event: any, orderIndex: number) => {
  holdSyotenCd = event.target.value;
  focusSyotenInput.value = true;
  changeSyotenTarget.value = preOrderList.value[orderIndex];
};
const searchSyoten = async (): Promise<void> => {
  store.commit("search/setSyotenDetailState", {
    toritugiCd: changeSyotenTarget.value.syoten.toritugiCd,
    toritugiSyotenCd: changeSyotenTarget.value.syoten.toritugiSyotenCd,
  });
  // 入力値が空だったら各値をリセットする
  if (changeSyotenTarget.value.syoten.toritugiSyotenCd === "") {
    changeSyotenTarget.value.syoten.syotenMei = "";
    changeSyotenTarget.value.syoten.toritugiSyotenCd = "";
    changeSyotenTarget.value.syoten.bansen = "";
    checkDuplicatedSyoten();
  } else {
    await store.dispatch("search/searchToritugiSyotenCd");
    const res = store.getters["search/getSyotenData"];
    if (res.syotenToritugiList.length > 0) {
      ref_selectSyoten(res.syotenToritugiList[0]);
    } else {
      //該当する書店が無ければ以前の状態に戻す
      changeSyotenTarget.value.syoten.toritugiSyotenCd = holdSyotenCd;
      notyf.error("該当する書店がありません");
    }
  }
};
// モーダルから検索されたとき↓↓
const openSearchSyotenModal = (orderIndex: number) => {
  changeSyotenTarget.value = preOrderList.value[orderIndex];
  propToritugiCd.value = preOrderList.value[orderIndex].syoten.toritugiCd;
  shopModalVisible.value = true;
};
const ref_selectSyoten = (selectedValue: {
  syotenMei: string;
  syotenCd: string;
  bansen: string;
  toritugiCd: string;
  toritugiSyotenCd: string;
}) => {
  changeSyotenTarget.value.syoten.toritugiCd = selectedValue.toritugiCd;
  changeSyotenTarget.value.syoten.toritugiSyotenCd =
    selectedValue.toritugiSyotenCd;
  changeSyotenTarget.value.syoten.syotenMei = selectedValue.syotenMei;
  changeSyotenTarget.value.syoten.bansen = selectedValue.bansen;

  checkDuplicatedSyoten();
};

// 書店の重複がないかチェックする
const checkDuplicatedSyoten = () => {
  preOrderList.value.forEach((preOrder) => {
    preOrder.syoten.duplicate = false;
  });
  const duplicatedSyoten = preOrderList.value.filter(
    (x, i, s) =>
      s
        .slice(0, s.length)
        .filter(
          (y) =>
            y.syoten.toritugiSyotenCd !== "" &&
            x.syoten.toritugiSyotenCd !== "" &&
            y.syoten.toritugiSyotenCd === x.syoten.toritugiSyotenCd
        ).length >= 2
  );
  duplicatedSyoten.forEach((dupSyoten) => {
    dupSyoten.syoten.duplicate = true;
  });
};

// 部数関連--------------------------------------------------------------
let holdQuantity = null as number | null;
const focusQuantity = (e: any, preOrderIndex: number, syosiIndex: number) => {
  holdQuantity = e.target.value;
  preOrderList.value[preOrderIndex].syosiList[syosiIndex].quantity = null;
};
const validateQuantity = (
  e: any,
  preOrderIndex: number,
  syosiIndex: number
) => {
  //符号無し整数を判定
  if (!e.target.value.match(/^[0-9]+$/)) {
    preOrderList.value[preOrderIndex].syosiList[syosiIndex].quantity = null;
  }
};
const blurQuantity = (e: any, preOrderIndex: number, syosiIndex: number) => {
  if (e.target.value === "") {
    preOrderList.value[preOrderIndex].syosiList[syosiIndex].quantity =
      holdQuantity;
  }
  holdQuantity = null;
};
// 列部数計算
const calcColumnTotal = (columnNum: number) => {
  let totalNum = 0;
  preOrderList.value.forEach((preOrder) => {
    preOrder.syosiList.forEach((syosi) => {
      if (syosi.columnNumber === columnNum && syosi.quantity !== null) {
        totalNum += Number(syosi.quantity);
      }
    });
  });
  return totalNum;
};
// 行部数計算
const calcRowTotal = (rowNum: number) => {
  let totalNum = 0;
  preOrderList.value.forEach((preOrder) => {
    if (preOrder.syoten.rowNumber === rowNum) {
      preOrder.syosiList.forEach((syosi) => {
        if (syosi.quantity !== null) {
          totalNum += Number(syosi.quantity);
        }
      });
    }
  });
  return totalNum;
};
// 総計計算
const calcTotal = () => {
  let totalNum = 0;
  preOrderList.value.forEach((preOrder) => {
    preOrder.syosiList.forEach((syosi) => {
      if (syosi.quantity !== null) totalNum += Number(syosi.quantity);
    });
  });
  return totalNum;
};

// キャンセルボタン------------------------------------------------------
const onClickCancel = () => {
  router.push("/preOrderList");
};
// 確認モーダル関連
const warningModalVisible = ref(false);
const excuteTransition = () => {
  fromModalNav = true;
  router.push(navTo.path);
};

// 画像ファイルのアップロード------------------------------------
const inputImg = ref();
const imgUrl = ref("");
const onClickInputImg = () => {
  inputImg.value.click();
};
const uploadImg = () => {
  const img = inputImg.value.files[0];
  if (img === undefined) {
    validImg(0);
    imgUrl.value =
      savedListData.value.imagePath !== null
        ? savedListData.value.imagePath
        : "";
  } else {
    validImg(img.size);
    imgUrl.value = URL.createObjectURL(img);
  }
};

// Excel関連-----------------------------------------------------

let currentDate = new Date();
// 年
const year = currentDate.getFullYear();
// 月
const month = currentDate.getMonth() + 1;
// 日
const day = currentDate.getDate();
// 時間
const hour = currentDate.getHours();
// 分
const min = currentDate.getMinutes();
// 秒
const sec = currentDate.getSeconds();

// ダウンロード処理（全体）
const isDownloading = ref(false); // ダウンロード中フラグ
const getExcelData = async () => {
  isDownloading.value = true;
  try {
    const url = isCreateNewList
      ? `${store.getters["getBaseUrl"]}/chumon/multi/downloadeExcelTemplate`
      : `${
          store.getters["getBaseUrl"]
        }/pre/chumon/download-excel?listId=${String(route.params.id)}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      responseType: "arraybuffer",
      responseEncoding: "binary",
    });
    downloadFile(res);
  } catch (error) {
    isDownloading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadFile = (resData: any) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${
    year +
    String(month).padStart(2, "0") +
    String(day).padStart(2, "0") +
    String(hour).padStart(2, "0") +
    String(min).padStart(2, "0")
  }_${inputItem.value.listName}.xlsx`;
  link.click();
  isDownloading.value = false;
};

// ダウンロード処理（書誌のみ）
const isDownloadingSyosi = ref(false); // ダウンロード中フラグ
const getExcelDataSyosi = async () => {
  isDownloadingSyosi.value = true;
  try {
    const url = `${
      store.getters["getBaseUrl"]
    }/pre/chumon/download-excel/add-template?listId=${String(route.params.id)}`;
    const res = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
      responseType: "arraybuffer",
      responseEncoding: "binary",
    });
    downloadFileSyosi(res);
  } catch (error) {
    isDownloadingSyosi.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadFileSyosi = (resData: any) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `${
    year +
    String(month).padStart(2, "0") +
    String(day).padStart(2, "0") +
    String(hour).padStart(2, "0") +
    String(min).padStart(2, "0")
  }_${inputItem.value.listName}（書誌のみ）.xlsx`;
  link.click();
  isDownloadingSyosi.value = false;
};

// アップロード関連
const isUploading = ref(false); // アップロード中フラグ
const inputFile = ref();
let error = reactive({
  hasError: false,
  message: "",
});
watch(
  () => error,
  () => {
    if (error.hasError === true) {
      isUploading.value = false;
      notyf.error({
        duration: 10000,
        message: error.message,
      });
    }
  },
  { deep: true }
);
const onClickUpload = () => {
  //「アップロード」ボタンを押下すると非表示中のinput=fileが発火する
  inputFile.value.click();
};
const resetFile = (e: any) => {
  e.target.value = "";
  error.hasError = false;
  error.message = "";
};
let FILE: any;
const uploadFile = (e: any) => {
  isUploading.value = true;
  FILE = e.target.files[0];
  const READER = new FileReader();

  READER.onload = async (e: any) => {
    const formData = new FormData();
    formData.append("multipartFile", FILE);
    formData.append(
      "id",
      route.params.id === "-1" ? "" : (route.params.id as any)
    ); // number型が許容されないので型アサーションを行う
    uploadToServer(formData);
  };
  // Fileオブジェクトバイナリデータとしてメモリ上に読み込む（読み込んだらonload部分を実行する）
  READER.readAsArrayBuffer(FILE);
};
// サーバーに投げる
const uploadToServer = async (sendData: any) => {
  const url = `${store.getters["getBaseUrl"]}/pre/chumon/upload-excel`;
  try {
    let isAccept = true;
    if (
      isCreateNewList &&
      (baseSyosiList.value.length > 1 ||
        baseSyosiList.value[0].janCd !== "" ||
        preOrderList.value.length > 1 ||
        preOrderList.value[0].syoten.toritugiSyotenCd !== "")
    ) {
      isAccept = confirm("入力データが削除されますがよろしいですか？");
    }
    if (isAccept) {
      const res = await axios.post(url, sendData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "content-type": "multipart/form-data",
        },
      });

      // エラーの削除
      listNameError.value.hasError = false;
      explanationError.value.hasError = false;
      displayPeriodError.value.hasError = false;
      syosiError.value.hasError = false;
      syotenError.value.hasError = false;
      // 表示期限のエラーバリデーションを発火させたいので一旦削除する
      // inputItem.value.startDate = "";
      // inputItem.value.endDate = "";

      // 各値の代入
      const displayData: typeof savedListData.value.displayDataList =
        res.data.displayDataList;
      if (displayData.length > 0) {
        // APIから取得したデータを番号順に並び変える
        displayData.forEach((dispData) => {
          dispData.syosiList.sort((a, b) => {
            return a.columnNumber - b.columnNumber;
          });
        });
        displayData.sort((a, b) => {
          return a.syoten.rowNumber - b.syoten.rowNumber;
        });

        // リスト編集の場合
        if (!isCreateNewList) {
          // 書誌リストが画面データと完全一致しているかバリデーション
          let toCompSyosiList = [] as BaseSyosiList[];
          // 取得データの書誌リストを作成
          for (const syosi of displayData[0].syosiList) {
            const syosiRes = await axios.get(
              `${store.getters["getBaseUrl"]}/syosi?syosiCd=${syosi.janCd}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
              }
            );
            const syosiTitle =
              syosiRes.data.syosiList.length > 0
                ? syosiRes.data.syosiList[0].title
                : "";
            toCompSyosiList.push({
              janCd: syosi.janCd,
              displayCode: syosi.janCd,
              syosiMei: syosiTitle,
              columnNumber: syosi.columnNumber,
              freeword: syosi.freeword,
            });
          }
          // 画面データと書誌の登録数が異なればエラー
          if (baseSyosiList.value.length !== toCompSyosiList.length) {
            isUploading.value = false;
            notyf.error("書誌データは画面上のデータと一致させてください");
            return;
          }
          // 画面データと書誌の並び順が異なればエラー
          for (const [baseIndex, base] of baseSyosiList.value.entries()) {
            if (base.janCd !== toCompSyosiList[baseIndex].janCd) {
              isUploading.value = false;
              notyf.error("書誌データは画面上のデータと一致させてください");
              return;
            }
          }
          // console.log("バリデーションエラーなし");

          // 注文リストに追加
          displayData.forEach((dispData) => {
            preOrderList.value.push(JSON.parse(JSON.stringify(dispData)));
          });
          reNumRow();
        }
        // リスト新規作成の場合
        else {
          // 書誌リストに格納
          baseSyosiList.value.splice(0);
          for (const syosi of displayData[0].syosiList) {
            const syosiRes = await axios.get(
              `${store.getters["getBaseUrl"]}/syosi?syosiCd=${syosi.janCd}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
              }
            );
            const syosiTitle =
              syosiRes.data.syosiList.length > 0
                ? syosiRes.data.syosiList[0].title
                : "";
            // 表示用
            baseSyosiList.value.push({
              janCd: syosi.janCd,
              displayCode: syosi.janCd,
              syosiMei: syosiTitle,
              columnNumber: syosi.columnNumber,
              freeword: syosi.freeword,
            });
          }
          // 注文リストに格納
          preOrderList.value.splice(0);
          // 表示用
          preOrderList.value = JSON.parse(JSON.stringify(displayData));
        }
      }
      isUploading.value = false;
    } else {
      isUploading.value = false;
    }
  } catch (error) {
    console.log(error);
    isUploading.value = false;
    // 404エラーの場合（DBに存在しないデータが入力された場合）、エラー内容をExcelでダウンロードする
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      // エラー内容のダウンロード
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
      downloadErrorFile(error.response?.data);
      // 取り込み完了分のデータ表示
      const displayData: typeof savedListData.value.displayDataList =
        error.response?.data.displayData.displayDataList;
      if (displayData.length > 0) {
        // APIから取得したデータを番号順に並び変える
        displayData.forEach((dispData) => {
          dispData.syosiList.sort((a, b) => {
            return a.columnNumber - b.columnNumber;
          });
        });
        displayData.sort((a, b) => {
          return a.syoten.rowNumber - b.syoten.rowNumber;
        });
        // 書誌リストに格納
        baseSyosiList.value.splice(0);
        for (const syosi of displayData[0].syosiList) {
          const syosiRes = await axios.get(
            `${store.getters["getBaseUrl"]}/syosi?syosiCd=${syosi.janCd}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
              },
            }
          );
          const syosiTitle =
            syosiRes.data.syosiList.length > 0
              ? syosiRes.data.syosiList[0].title
              : "";
          // 表示用
          baseSyosiList.value.push({
            janCd: syosi.janCd,
            displayCode: syosi.janCd,
            syosiMei: syosiTitle,
            columnNumber: syosi.columnNumber,
            freeword: syosi.freeword,
          });
        }
        // 注文リストに格納
        preOrderList.value.splice(0);
        // 表示用
        preOrderList.value = JSON.parse(JSON.stringify(displayData));
      }
    } else if (axios.isAxiosError(error) && error.response?.data.userMessage) {
      // console.log(error.response?.status);
      notyf.error({
        duration: 10000,
        message: error.response?.data.userMessage,
      });
    } else if (axios.isAxiosError(error) && error.response?.status === 500) {
      notyf.error({
        duration: 10000,
        message: "フォーマットが異なるためアップロードできません",
      });
    } else {
      alert("アップロードに失敗しました");
    }
  }
};
// エラーExcelのダウンロード
const downloadErrorFile = async (errorInfo: any) => {
  isUploading.value = true;

  const formData = new FormData();
  formData.append("file", FILE);
  formData.append(
    "errorJanCdCellData",
    new Blob([JSON.stringify(errorInfo.errorJanCdCellData)], {
      type: "application/json",
    })
  );
  formData.append(
    "errorSyotenInfoCellData",
    new Blob([JSON.stringify(errorInfo.errorSyotenInfoCellData)], {
      type: "application/json",
    })
  );
  try {
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/pre/chumon/error-download-excel`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "content-type": "multipart/form-data",
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );

    // Excelファイルのダウンロード
    let blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `事前注文リスト_エラー内容.xlsx`;
    link.click();
    isUploading.value = false;
  } catch (error) {
    alert("エラー内容の取得に失敗しました");
    console.log(error);
  }
};

// 登録関連------------------------------------------------------
const registerList = async () => {
  const hasError = validateOnRegister();
  if (hasError) {
    notyf.error("入力内容を確認してください");
  } else {
    // 送付データの生成
    let syotenList: any = [];
    let syosiList: any = [];
    let quantityList: any = [];
    preOrderList.value.forEach((preOrder) => {
      syotenList.push({
        toritugiCd: preOrder.syoten.toritugiCd,
        toritugiSyotenCd: preOrder.syoten.toritugiSyotenCd,
        syotenMei: preOrder.syoten.syotenMei,
        rowNumber: Number(preOrder.syoten.rowNumber),
        registerDate: preOrder.syoten.registerDate,
        remarks: preOrder.syoten.remarks,
      });
      preOrder.syosiList.forEach((syosi) => {
        quantityList.push({
          rowNumber: preOrder.syoten.rowNumber,
          columnNumber: Number(syosi.columnNumber),
          quantity: Number(syosi.quantity),
        });
      });
    });
    baseSyosiList.value.forEach((baseSyosi) => {
      // フリー入力されていたらJANコードを削除する
      const hasFreeword = restrictSyosiInput(baseSyosi);
      syosiList.push({
        janCd: hasFreeword ? null : baseSyosi.janCd,
        columnNumber: Number(baseSyosi.columnNumber),
        freeword: hasFreeword ? baseSyosi.freeword : null,
      });
    });
    try {
      if (isCreateNewList) {
        let listData = {
          listName: inputItem.value.listName,
          description: inputItem.value.explanation,
          startDate: isIndefinite.value ? null : inputItem.value.startDate,
          endDate: isIndefinite.value ? null : inputItem.value.endDate,
          syotenList: syotenList,
          syosiList: syosiList,
          quantityList: quantityList,
          version: savedListData.value.version,
        };
        // console.log(listData);

        let postData = new FormData();
        postData.append(
          "form",
          new Blob([JSON.stringify(listData)], { type: "application/json" })
        );
        postData.append(
          "imageFile",
          inputImg.value.files[0] !== undefined ? inputImg.value.files[0] : null
        );
        await axios.post(
          `${store.getters["getBaseUrl"]}/pre/chumon/create`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        notyf.success("リストを作成しました");
      } else {
        let listData = {
          id: Number(route.params.id),
          listName: inputItem.value.listName,
          description: inputItem.value.explanation,
          startDate: isIndefinite.value ? null : inputItem.value.startDate,
          endDate: isIndefinite.value ? null : inputItem.value.endDate,
          syotenList: syotenList,
          syosiList: syosiList,
          quantityList: quantityList,
          version: savedListData.value.version,
        };
        // console.log(listData);
        let postData = new FormData();
        postData.append(
          "form",
          new Blob([JSON.stringify(listData)], { type: "application/json" })
        );
        postData.append(
          "imageFile",
          inputImg.value.files[0] !== undefined ? inputImg.value.files[0] : null
        );
        await axios.post(
          `${store.getters["getBaseUrl"]}/pre/chumon/edit`,
          postData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        );
        notyf.success("リストを作成しました");
      }
      fromModalNav = true;
      router.push("/preOrderList");
    } catch (error) {
      console.log(error);
      if (axios.isAxiosError(error) && error.response?.status === 409) {
        notyf.error({
          duration: 10000,
          message: error.response.data.userMessage,
        });
        getInputtingExcel(syotenList, syosiList, quantityList);
      } else if (
        axios.isAxiosError(error) &&
        (error.response?.status === 400 || error.response?.status === 415)
      ) {
        notyf.error({
          duration: 10000,
          message: error.response.data.userMessage,
        });
      } else {
        alert("注文リスト作成に失敗しました");
      }
    }
  }
};
// 排他制御でデータ更新不可の際に、ユーザーが入力していたデータをExcel形式で出力する機能
const getInputtingExcel = async (
  syotenList: any[],
  syosiList: any[],
  quantityList: any[]
) => {
  let listData = {
    id: Number(route.params.id),
    listName: inputItem.value.listName,
    description: inputItem.value.explanation,
    startDate: isIndefinite.value ? null : inputItem.value.startDate,
    endDate: isIndefinite.value ? null : inputItem.value.endDate,
    syotenList: syotenList,
    syosiList: syosiList,
    quantityList: quantityList,
    version: savedListData.value.version,
  };
  try {
    const res = await axios.post(
      `${store.getters["getBaseUrl"]}/pre/chumon/download-excel/exlusive-control`,
      listData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );

    // Excelファイルのダウンロード
    let blob = new Blob([res.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `事前注文リスト_入力内容.xlsx`;
    link.click();
    isUploading.value = false;
  } catch (error) {
    alert("入力内容の取得に失敗しました");
    console.log(error);
  }
};

// レイアウト関連--------------------------------------------------------------
// 書誌リストの書名の高さを可変にする
const syosiHeight = ref("");
const syosiTitleHeight = () => {
  const targetElm = document.getElementsByClassName("syosi_title");
  const clientHeightArray = Array.from(targetElm).map(
    (elm) => elm.clientHeight
  );
  syosiHeight.value = Math.max(...clientHeightArray) + "px";
};
// 書店リストのヘッダーの固定位置を取得（書名の高さが可変のためそれに合わせる）
const syotenHeaderHight = ref("");
const syotenHeaderPosition = () => {
  const targetElm = document.getElementsByClassName("syosi_table_base_content");
  syotenHeaderHight.value = targetElm[0].clientHeight + "px";
};
watch(baseSyosiList.value, () => {
  setTimeout(() => {
    syosiTitleHeight();
    syotenHeaderPosition();
  }, 100);
});
// 明細追加時にスクロールする
const toScrollTableBottom = async () => {
  let el = document.getElementsByClassName("syosi_table_content");
  if (el.length > 0) {
    el[0].scrollTo({
      top: el[0].scrollHeight,
      behavior: "smooth",
    });
  }
};
const toScrollTableRight = async () => {
  let el = document.getElementsByClassName("syosi_table_content");
  if (el.length > 0) {
    el[0].scrollTo({
      left: el[0].scrollWidth,
      behavior: "smooth",
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CreateList", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
      CreateList_FromDashboard: _unref(fromDashboard),
    }])
  }, [
    (!_unref(fromDashboard))
      ? (_openBlock(), _createBlock(PankuzuHeader, {
          key: 0,
          isActive_SidebarFlg: props.isActive_SidebarFlg,
          currentPathList: currentPathList
        }, null, 8, ["isActive_SidebarFlg"]))
      : _createCommentVNode("", true),
    (shopModalVisible.value)
      ? (_openBlock(), _createBlock(ModalShopList, {
          key: 1,
          toritugiCd: propToritugiCd.value,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (shopModalVisible.value = false)),
          onRef_selectSyoten: ref_selectSyoten
        }, null, 8, ["toritugiCd"]))
      : _createCommentVNode("", true),
    (syosiModalVisible.value)
      ? (_openBlock(), _createBlock(ModalSyosiList, {
          key: 2,
          "ikkatu-flg": syosiIkkatuFlg.value,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (syosiModalVisible.value = false)),
          onRef_selectSyosi: ref_selectSyosi,
          onRef_selectMultiSyosi: ref_selectMultiSyosi
        }, null, 8, ["ikkatu-flg"]))
      : _createCommentVNode("", true),
    (warningModalVisible.value)
      ? (_openBlock(), _createBlock(ModalWarningMessage, {
          key: 3,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (warningModalVisible.value = false)),
          onExecute: excuteTransition,
          message: '入力データが削除されますがよろしいですか？'
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      (_unref(isCreateNewList))
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, "新規事前注文リスト作成"))
        : (_unref(fromDashboard))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, "事前注文リスト参照"))
          : (_openBlock(), _createElementBlock("span", _hoisted_4, "事前注文リスト編集"))
    ]),
    (!_unref(fromDashboard))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: onClickCancel,
              class: "CreateList_BtnGray"
            }, _hoisted_8),
            (isListOpen.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "CreateList_BtnGreen",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (isListOpen.value = !isListOpen.value)),
                  style: {"height":"30px"}
                }, " リスト閉 "))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "CreateList_BtnGreen",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (isListOpen.value = !isListOpen.value)),
                  style: {"height":"30px"}
                }, " リスト開 ")),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: _normalizeClass(["CreateList_BtnGreen", { disabled_btn: isDownloading.value }]),
              onClick: getExcelData,
              disabled: isDownloading.value
            }, [
              (!isDownloading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "download",
                    style: {"display":"inline-block"}
                  }))
                : _createCommentVNode("", true),
              (isDownloading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                : _createCommentVNode("", true),
              _createTextVNode(" ダウンロード"),
              (!_unref(isCreateNewList))
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(全体)"))
                : _createCommentVNode("", true)
            ], 10, _hoisted_11),
            (!_unref(isCreateNewList))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: _normalizeClass(["CreateList_BtnGreen", { disabled_btn: isDownloadingSyosi.value }]),
                  onClick: getExcelDataSyosi,
                  disabled: isDownloadingSyosi.value
                }, [
                  (!isDownloadingSyosi.value)
                    ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                        key: 0,
                        icon: "download",
                        style: {"display":"inline-block"}
                      }))
                    : _createCommentVNode("", true),
                  (isDownloadingSyosi.value)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                    : _createCommentVNode("", true),
                  _createTextVNode(" ダウンロード(書誌のみ) ")
                ], 10, _hoisted_14))
              : _createCommentVNode("", true),
            _createElementVNode("input", {
              onChange: uploadFile,
              onClick: resetFile,
              type: "file",
              ref_key: "inputFile",
              ref: inputFile,
              accept: ".xlsx",
              style: {"display":"none"}
            }, null, 544),
            _createElementVNode("button", {
              onClick: onClickUpload,
              class: _normalizeClass(["CreateList_BtnGreen", { disabled_btn: isUploading.value }]),
              disabled: isUploading.value
            }, [
              (!isUploading.value)
                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                    key: 0,
                    icon: "upload",
                    style: {"display":"inline-block"}
                  }))
                : _createCommentVNode("", true),
              (isUploading.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17))
                : _createCommentVNode("", true),
              _hoisted_18
            ], 10, _hoisted_16)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_Transition, null, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", { class: "CreateList_Close" }, " リスト名：" + _toDisplayString(inputItem.value.listName), 513), [
            [_vShow, !isListOpen.value]
          ])
        ]),
        _: 1
      }),
      _createElementVNode("table", _hoisted_20, [
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("tr", null, [
              _hoisted_21,
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((inputItem.value.listName) = $event)),
                  type: "text",
                  class: "Input_Long",
                  disabled: _unref(fromDashboard)
                }, null, 8, _hoisted_22), [
                  [_vModelText, inputItem.value.listName]
                ]),
                (listNameError.value.hasError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(listNameError.value.message), 1))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, isListOpen.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("tr", null, [
              _hoisted_24,
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputItem.value.explanation) = $event)),
                  disabled: _unref(fromDashboard)
                }, null, 8, _hoisted_25), [
                  [_vModelText, inputItem.value.explanation]
                ]),
                (explanationError.value.hasError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(explanationError.value.message), 1))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, isListOpen.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("tr", null, [
              _hoisted_27,
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    (imgUrl.value === '')
                      ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                          key: 0,
                          icon: "image",
                          class: "img_icon"
                        }))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: imgUrl.value
                        }, null, 8, _hoisted_30))
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("input", {
                      onChange: uploadImg,
                      type: "file",
                      ref_key: "inputImg",
                      ref: inputImg,
                      accept: "image/*",
                      style: {"display":"none"}
                    }, null, 544),
                    (!_unref(fromDashboard))
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "CreateList_BtnGreen",
                          onClick: onClickInputImg
                        }, " 画像選択 "))
                      : _createCommentVNode("", true),
                    (imgError.value.hasError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(imgError.value.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 512), [
              [_vShow, isListOpen.value]
            ])
          ]),
          _: 1
        }),
        _createVNode(_Transition, null, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("tr", null, [
              _hoisted_32,
              _createElementVNode("td", null, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((inputItem.value.startDate) = $event)),
                  type: "date",
                  class: "Input_Short",
                  disabled: isIndefinite.value || _unref(fromDashboard)
                }, null, 8, _hoisted_33), [
                  [_vModelText, inputItem.value.startDate]
                ]),
                _createTextVNode(" ~ "),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputItem.value.endDate) = $event)),
                  type: "date",
                  class: "Input_Short",
                  disabled: isIndefinite.value || _unref(fromDashboard)
                }, null, 8, _hoisted_34), [
                  [_vModelText, inputItem.value.endDate]
                ]),
                _createElementVNode("span", _hoisted_35, [
                  _hoisted_36,
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "mukigenCheck",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((isIndefinite).value = $event)),
                    disabled: _unref(fromDashboard)
                  }, null, 8, _hoisted_37), [
                    [_vModelCheckbox, isIndefinite.value]
                  ])
                ]),
                (displayPeriodError.value.hasError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(displayPeriodError.value.message), 1))
                  : _createCommentVNode("", true)
              ])
            ], 512), [
              [_vShow, isListOpen.value]
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("table", _hoisted_39, [
        _createElementVNode("tr", _hoisted_40, [
          _createElementVNode("td", null, [
            (preOrderList.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  (!_unref(fromDashboard))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createElementVNode("div", _hoisted_43, [
                          _hoisted_44,
                          _createElementVNode("div", null, [
                            (syosiError.value.hasError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_45, _toDisplayString(syosiError.value.message), 1))
                              : _createCommentVNode("", true),
                            (syotenError.value.hasError)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_46, _toDisplayString(syotenError.value.message), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("button", {
                          onClick: deleteAll,
                          class: "CreateList_BtnGreen"
                        }, " すべて削除 ")
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _hoisted_49,
                    _hoisted_50,
                    _createElementVNode("div", {
                      style: _normalizeStyle({ height: syosiHeight.value })
                    }, "書名", 4),
                    _hoisted_51
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_unref(draggable), {
                        modelValue: baseSyosiList.value,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((baseSyosiList).value = $event)),
                        disabled: _unref(fromDashboard) || focusSyosiInput.value,
                        group: "baseSyosi",
                        "item-key": "janCd",
                        tag: "div",
                        style: {"display":"flex"},
                        onChange: onSortSyosi
                      }, {
                        item: _withCtx(({ element: base, index: baseIndex }) => [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", null, _toDisplayString(calcColumnTotal(base.columnNumber)) + "部", 1),
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(base.columnNumber) + " ", 1),
                              (!_unref(fromDashboard))
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    onClick: ($event: any) => (deleteColumn(baseIndex)),
                                    class: "CreateList_Table_Icon delete_col",
                                    icon: "trash-can"
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["cd_input", { input_disabled: restrictSyosiInput(base) }])
                            }, [
                              (!restrictSyosiInput(base) && !_unref(fromDashboard))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    class: "CreateList_Table_Inputdblclick",
                                    type: "text",
                                    placeholder: "商品コード",
                                    "onUpdate:modelValue": ($event: any) => ((base.displayCode) = $event),
                                    onDblclick: ($event: any) => {
                              syosiIkkatuFlg.value = false;
                              openSearchSyosiModal(baseIndex);
                            },
                                    onFocus: ($event: any) => (focusSyosiCd(baseIndex)),
                                    onChange: ($event: any) => (searchSyosi($event, baseIndex)),
                                    onBlur: _cache[10] || (_cache[10] = ($event: any) => (focusSyosiInput.value = false))
                                  }, null, 40, _hoisted_55)), [
                                    [_vModelText, base.displayCode]
                                  ])
                                : (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(base.displayCode), 1))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["syosi_title", { input_disabled: restrictSyosiInput(base) }])
                            }, _toDisplayString(base.syosiMei), 3),
                            _createElementVNode("div", _hoisted_57, [
                              (!_unref(fromDashboard))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((base.freeword) = $event)
                                  }, null, 8, _hoisted_58)), [
                                    [_vModelText, base.freeword]
                                  ])
                                : (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(base.freeword), 1))
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"]),
                      _createElementVNode("div", {
                        style: _normalizeStyle([{"min-width":"412px","background":"#fff"}, { height: syotenHeaderHight.value }])
                      }, null, 4)
                    ]),
                    _createElementVNode("table", _hoisted_60, [
                      _createElementVNode("thead", {
                        style: _normalizeStyle({ top: syotenHeaderHight.value })
                      }, [
                        _createElementVNode("tr", null, [
                          _hoisted_61,
                          _hoisted_62,
                          _hoisted_63,
                          _hoisted_64,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseSyosiList.value.length, (n) => {
                            return (_openBlock(), _createElementBlock("th", {
                              class: "midasi_busu",
                              key: n
                            }, " 部数 "))
                          }), 128)),
                          _hoisted_65,
                          _hoisted_66
                        ])
                      ], 4),
                      _createVNode(_unref(draggable), {
                        modelValue: preOrderList.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((preOrderList).value = $event)),
                        disabled: _unref(fromDashboard) || focusSyotenInput.value,
                        group: "syosi",
                        tag: "tbody",
                        "item-key": "janCd",
                        onChange: onSortSyoten
                      }, {
                        item: _withCtx(({ element: item, index: itemIndex }) => [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_67, [
                              _createTextVNode(_toDisplayString(calcRowTotal(item.syoten.rowNumber)), 1),
                              _hoisted_68,
                              _createTextVNode("部 ")
                            ]),
                            _createElementVNode("td", _hoisted_69, [
                              (item.syoten.duplicate)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_70, " 重複 "))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(item.syoten.rowNumber), 1)
                            ]),
                            _createElementVNode("td", _hoisted_71, [
                              _createElementVNode("select", {
                                value: item.syoten.toritugiCd,
                                onChange: ($event: any) => (inputToritugi($event, itemIndex)),
                                class: "Move_With_Enter",
                                disabled: _unref(fromDashboard),
                                ref: setSelectRef
                              }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(toritugiList.value, (option, index) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: option.toritugiCd,
                                    key: index
                                  }, _toDisplayString(option.toritugiMei), 9, _hoisted_73))
                                }), 128))
                              ], 40, _hoisted_72),
                              _createElementVNode("p", _hoisted_74, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "date",
                                  "onUpdate:modelValue": ($event: any) => ((item.syoten.registerDate) = $event),
                                  style: {"width":"100px","font-size":"12px"},
                                  tabindex: "-1"
                                }, null, 8, _hoisted_75), [
                                  [_vModelText, item.syoten.registerDate]
                                ])
                              ])
                            ]),
                            _createElementVNode("td", _hoisted_76, [
                              (!_unref(fromDashboard))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    class: "inputDblClick Move_With_Enter",
                                    type: "text",
                                    placeholder: "書店コード",
                                    "onUpdate:modelValue": ($event: any) => ((item.syoten.toritugiSyotenCd) = $event),
                                    onDblclick: ($event: any) => (openSearchSyotenModal(itemIndex)),
                                    onFocus: ($event: any) => (focusSyotenCd($event, itemIndex)),
                                    onChange: searchSyoten,
                                    onBlur: _cache[12] || (_cache[12] = ($event: any) => (focusSyotenInput.value = false)),
                                    onkeydown: "return event.keyCode !== 69"
                                  }, null, 40, _hoisted_77)), [
                                    [_vModelText, item.syoten.toritugiSyotenCd]
                                  ])
                                : (_openBlock(), _createElementBlock("input", {
                                    key: 1,
                                    class: "input_disabled",
                                    type: "text",
                                    placeholder: "書店コード",
                                    value: item.syoten.toritugiSyotenCd,
                                    disabled: ""
                                  }, null, 8, _hoisted_78)),
                              _withDirectives(_createElementVNode("input", {
                                class: "input_adjust input_disabled Move_With_Enter",
                                type: "text",
                                placeholder: "番線",
                                "onUpdate:modelValue": ($event: any) => ((item.syoten.bansen) = $event),
                                onFocus: _cache[13] || (_cache[13] = ($event: any) => (focusSyotenInput.value = true)),
                                onBlur: _cache[14] || (_cache[14] = ($event: any) => (focusSyotenInput.value = false)),
                                disabled: ""
                              }, null, 40, _hoisted_79), [
                                [_vModelText, item.syoten.bansen]
                              ]),
                              _hoisted_80,
                              _withDirectives(_createElementVNode("input", {
                                class: "input_full input_disabled",
                                type: "text",
                                placeholder: "書店名",
                                "onUpdate:modelValue": ($event: any) => ((item.syoten.syotenMei) = $event),
                                disabled: ""
                              }, null, 8, _hoisted_81), [
                                [_vModelText, item.syoten.syotenMei]
                              ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.syosiList, (syosi, syosiIndex) => {
                              return (_openBlock(), _createElementBlock("td", {
                                key: syosiIndex,
                                style: {"text-align":"center"}
                              }, [
                                (!_unref(fromDashboard))
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      type: "number",
                                      "onUpdate:modelValue": ($event: any) => ((syosi.quantity) = $event),
                                      onFocus: ($event: any) => (
                              focusQuantity($event, itemIndex, syosiIndex)
                            ),
                                      onChange: ($event: any) => (
                              validateQuantity($event, itemIndex, syosiIndex)
                            ),
                                      onBlur: ($event: any) => (blurQuantity($event, itemIndex, syosiIndex))
                                    }, null, 40, _hoisted_82)), [
                                      [_vModelText, syosi.quantity]
                                    ])
                                  : (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(syosi.quantity), 1))
                              ]))
                            }), 128)),
                            _createElementVNode("td", _hoisted_84, [
                              (!_unref(fromDashboard))
                                ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                    key: 0,
                                    type: "text",
                                    "onUpdate:modelValue": ($event: any) => ((item.syoten.remarks) = $event),
                                    style: {"width":"300px"}
                                  }, null, 8, _hoisted_85)), [
                                    [_vModelText, item.syoten.remarks]
                                  ])
                                : (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(item.syoten.remarks), 1))
                            ]),
                            _createElementVNode("td", _hoisted_87, [
                              (!_unref(fromDashboard))
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    onClick: ($event: any) => (deleteRow(itemIndex)),
                                    class: "CreateList_Table_Icon",
                                    icon: "trash-can"
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "disabled"])
                    ])
                  ]),
                  (!_unref(fromDashboard))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _createElementVNode("button", {
                          class: "CreateList_BtnGreen",
                          onClick: addPreOrderMeisai,
                          style: {"height":"30px"}
                        }, " 行追加 "),
                        _createElementVNode("div", _hoisted_89, [
                          _createElementVNode("span", _hoisted_90, "計" + _toDisplayString(calcTotal()) + "部", 1),
                          _createElementVNode("button", {
                            class: "CreateList_BtnGreen",
                            onClick: addBaseMeisai,
                            style: {"height":"30px"}
                          }, " 列追加 "),
                          _createElementVNode("button", {
                            class: "CreateList_BtnGreen",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => {
                      syosiIkkatuFlg.value = true;
                      syosiModalVisible.value = true;
                    }),
                            style: {"height":"30px"}
                          }, " 書誌一括追加 ")
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_91, " 書誌を追加するとここに表示されます "))
          ])
        ])
      ])
    ]),
    (!_unref(fromDashboard))
      ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
          _createElementVNode("button", {
            onClick: onClickCancel,
            class: "CreateList_BtnGray"
          }, _hoisted_94),
          _createElementVNode("button", {
            onClick: registerList,
            class: "CreateList_BtnGreen"
          }, _hoisted_96)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})